import { Link } from "react-router-dom";

export default function CTASection() {
  return (
    <section className="relative w-full py-20 md:py-28 overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20panoramic%20illustration%20with%20warm%20amber%20and%20soft%20coral%20gradient%2C%20abstract%20flowing%20ink%20brush%20strokes%2C%20ethereal%20atmosphere%2C%20dreamy%20artistic%20composition%2C%20subtle%20golden%20light%20particles%2C%20cinematic%20widescreen%2C%20warm%20inviting%20mood&width=1920&height=800&seq=cta-bg-home&orientation=landscape"
          alt=""
          className="w-full h-full object-cover object-top"
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-r from-black/60 via-black/40 to-black/50"></div>

      <div className="relative z-10 w-full px-4 md:px-6">
        <div className="max-w-4xl">
          <h2 className="text-2xl md:text-4xl font-black text-white mb-4 md:mb-6 lowercase"
            style={{ fontFamily: "var(--font-heading)" }}>
            现在就开始你的韩漫之旅
          </h2>
          <div className="flex flex-col sm:flex-row items-start sm:items-center gap-4 md:gap-8">
            <Link
              to="/category/fantasy"
              className="inline-flex items-center gap-2 px-6 md:px-8 py-3 md:py-3.5 text-sm md:text-base font-semibold bg-white text-foreground-900 rounded-full hover:bg-foreground-50 transition-all duration-300 whitespace-nowrap"
            >
              探索热门漫画
              <span className="w-6 h-6 flex items-center justify-center rounded-full bg-foreground-900">
                <i className="ri-arrow-right-line text-xs text-white"></i>
              </span>
            </Link>
            <p className="text-sm md:text-base text-white/70 leading-relaxed max-w-sm">
              海量高清韩国漫画，完全免费，<br className="hidden md:block" />随时随地畅享阅读乐趣
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}